// extracted by mini-css-extract-plugin
module.exports = {"wetstock-data-container":"WetstockData_wetstock-data-container__2lP9S","last-delivery-title":"WetstockData_last-delivery-title__7qzuQ"};